import React from 'react';
import {
  fetchCommitteesMembers, fetchCommitteesMembersByCommitteeMemberId
} from '../../../../../Redux/Actions/Admin/ManageCommitteeMemberAction';
import { fetchAllMembershipsForBoard, fetchMembershipsForBoardCount, fetchMembershipsForBoardByPage } from '../../../../../Redux/Actions/EndUser/MembershipsForBoardAction';
import { auth } from '../../../../../services';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import IsLoading from '../../../../Shared/Loading/IsLoading';
import {
  Row,
  Col,
  Button,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  FormGroup,
  Form
} from 'reactstrap';
import '../../MyMemberships/AuthorizedMembers/AuthorizedMembers.scss';
import { provideIntlService } from '@progress/kendo-react-intl';
import MUIDataTable from "mui-datatables";
import CommitteeMemberListGridFooter from './CommitteeMemberListGridFooter';

import CustomSearchRender from './CustomSearchRender';
import { CSVLink } from "react-csv";
import Moment from 'react-moment';


let timer = null;
class CommitteeMemberList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      committeeMemberId: 0,
      allMemberships: [],
      csvDownloadString: '',
      membershipsForBoards: [],
      membershipsForBoardsCount: 0,
      currentPage: 0,
      rowsPerPage: 10,
      isLoading: true,
      searchQuery: '',
      columns: [
        // {
        //   name: "memberNumber",
        //   label: "Member #",
        //   options: {
        //     filter: true,
        //     sort: true,
        //   }
        // },
        {
          name: "fullName",
          label: "Name",
          options: {
            filter: false,
            sort: true,
            searchable: false,
          }
        },
        {
          name: "organizationName",
          label: "Organization",
          options: {
            filter: false,
            sort: true,
            searchable: false,
          }
        },
        // {
        //   name: "phone",
        //   label: "Phone",
        //   options: {
        //     filter: false,
        //     sort: true,
        //     searchable: false
        //   }
        // },
        // {
        //   name: "email",
        //   label: "Email",
        //   options: {
        //     filter: true,
        //     sort: true,
        //     searchable: true,
        //   }
        // },
        {
          name: "membershipType",
          label: "Type",
          options: {
            filter: false,
            sort: true,
            searchable: false,
          }
        },
        {
          name: "membershipStatus",
          label: "Status",
          options: {
            filter: false,
            sort: true,
            searchable: false,
          }
        },
        {
          name: "membershipExpirationDate",
          label: "Expiration Date",
          options: {
            filter: false,
            sort: true,
            searchable: false,
            customBodyRender: (value, tableMeta, updateValue) => {

              let dateArr = '';
              let parsedDate = '';
              if (value) {
                dateArr = value.split('T');
                if (dateArr && dateArr[0]) {
                  parsedDate = dateArr[0];
                }
              }

              return (
                <Moment format="MM-DD-YYYY">
                  {parsedDate || ''}
                </Moment>
              );
            }
          }
        },
        // {
        //   name: "address1",
        //   label: "Address 1",
        //   options: {
        //     filter: false,
        //     sort: true,
        //     searchable: false,
        //   }
        // },
        // {
        //   name: "mailingAddress2",
        //   label: "Address 2",
        //   options: {
        //     filter: false,
        //     sort: true,
        //     searchable: false,
        //   }
        // },
        {
          name: "mailingCity",
          label: "City",
          options: {
            filter: false,
            sort: true,
            searchable: false,
          }
        },
        {
          name: "state",
          label: "State",
          options: {
            filter: false,
            sort: true,
            searchable: false,
          }
        },
        {
          name: "mailingZip",
          label: "Zip",
          options: {
            filter: false,
            sort: true,
            searchable: false,
          }
        },
        {
          name: "county",
          label: "County",
          options: {
            filter: false,
            sort: true,
            searchable: false,
          }
        }
      ],
    };

  }
  componentDidMount() {

    this.getMembershipsForDownload();
    this.fetchMembershipsByPage();
    this.fetchMembershipsForBoardCount();


    const committeeMemberId = this.props.location.pathname.replace("/mycommittee/", "");
    // console.log("SelectedCommittee", committeeMemberId);

    this.setState({
      committeeMemberId: committeeMemberId
    })
    // this.props.fetchCommitteesMembersByCommitteeMemberId(committeeMemberId);
    // console.log(this.state.membershipsForBoards);
  }

  fetchMembershipsByPage() {

    this.props.fetchMembershipsForBoardByPage({
      page: this.state.currentPage,
      itemForPage: this.state.rowsPerPage,
      searchQuery: this.state.searchQuery
    }).then(() => {
      // console.log({fetchMembershipsForBoardByPage: this.props.membershipsForBoards?.membershipsForBoards});

      const currentMembershipsForBoards = this.state.membershipsForBoards;

      this.setState({
        // membershipsForBoards: [...currentMembershipsForBoards, ...(this.props.membershipsForBoards?.membershipsForBoards || [])]
        membershipsForBoards: this.props.membershipsForBoards?.membershipsForBoards || []
      });
    });
  }

  fetchMembershipsForBoardCount() {
    this.props.fetchMembershipsForBoardCount(this.state.searchQuery).then(() => {
      // console.log('Count: ' + this.props.membershipsForBoards?.membershipsForBoardsCount);
      this.setState({
        membershipsForBoardsCount: this.props.membershipsForBoards?.membershipsForBoardsCount || 0
      });
    });
  }

  onChangePage(pageNum) {
    // console.log('Page now: ' + pageNum);
    this.setState({
      currentPage: pageNum || 0
    }, () => this.fetchMembershipsByPage());
  };

  onChangeRowsPerPage(rowsPerPage) {
    // console.log('rowsPerPage now: ' + rowsPerPage);
    this.setState({
      rowsPerPage: rowsPerPage || 10
    }, () => this.fetchMembershipsByPage());

  }

  handleSearchClick() {
    if (this.state.searchQuery) {
      this.fetchMembershipsByPage();
      this.fetchMembershipsForBoardCount();
      this.getMembershipsForDownload();
    }
  }

  handleSearchHide() {

    if (this.state.searchQuery) {
      this.setState({
        currentPage: 0,
        searchQuery: ""
      }, () => {
        this.fetchMembershipsByPage();
        this.fetchMembershipsForBoardCount();
        this.getMembershipsForDownload();
      });
    }

  }
  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  getMembershipsForDownload() {
    this.setState({
      downloadDisable: true
    });
    this.props.fetchAllMembershipsForBoard(this.state.searchQuery).then(() => {
      let allMemberships = [];

      (this.props.membershipsForBoards.allMemberships).map((membership, idx) => {

        const rowData = {
          index: idx,
          data: [],
        };

        this.state.columns.map((column) => {
          const colName = column.name;
          rowData.data.push(membership[colName] ?? '');
        })

        return allMemberships.push(rowData);
      });

      this.setState({
        allMemberships: allMemberships,
        downloadDisable: false
      });
    });
  }

  render() {

    const options = {
      filterType: 'textField',
      selectableRows: 'none',
      filter: false,
      search: true,
      sort: false,
      viewColumns: false,
      print: false,
      download: false, //this.state.downloadDisable ? 'disabled' : true,
      count: this.state.membershipsForBoardsCount,
      page: 0,//this.state.currentPage,
      serverSide: true,
      onChangePage: (currPage) => { this.onChangePage(currPage) },
      onChangeRowsPerPage: (currentRowsPerPage) => { this.onChangeRowsPerPage(currentRowsPerPage) },
      rowsPerPage: this.state.currentRowsPerPage,
      customFooter: (count, page, rowsPerPage, changeRowsPerPage, changePage, textLabels) => {
        return (
          <CommitteeMemberListGridFooter
            count={count}
            page={this.state.currentPage}
            rowsPerPage={rowsPerPage}
            changeRowsPerPage={changeRowsPerPage}
            changePage={changePage}
            textLabels={textLabels}
          />
        );
      },
      onDownload: (buildHead, buildBody, columns, data) => {

        // console.log({columns, allMemberships: this.state.allMemberships, data});

        const header = buildHead(columns);
        const body = buildBody(this.state.allMemberships);

        this.setState({
          csvDownloadString: header + body
        }, () => {
          document.getElementById('react_csv_link').click();
        });
        return false;
      },
      onSearchChange: (searchText) => {
        this.setState({
          currentPage: 0,
          searchQuery: searchText
        });
      },
      customSearchRender: (searchText, handleSearch, hideSearch, options) => {
        return (
          <CustomSearchRender
            searchText={searchText}
            onSearch={handleSearch}
            onHide={() => { this.handleSearchHide(); hideSearch(); }}
            options={options}
            onSearchClick={() => { this.handleSearchClick() }}
          />
        );
      }
    };
    return (
      <React.Fragment>
        <div className="account-tab-content">
          <div>
            <div>
              <h1 className="pt-3 pb-3">Memberships</h1>
            </div>
          </div>
        </div>
        <div className="account-tab-content authorized-members">
          <div className="table-responsive">
            <MUIDataTable
              data={this.state.membershipsForBoards || []}
              columns={this.state.columns}
              options={options}
            />
          </div>
        </div>
        <CSVLink
          filename={"Memberships.csv"}
          data={this.state.csvDownloadString}
          id='react_csv_link'
        >
        </CSVLink>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    committeeMembers: state.committeeMember,
    common: state.common,
    selectedCommittee: state.accountDetails.selectedUserCommittee,
    membershipsForBoards: state.membershipsForBoard,
  };
}

export default withRouter(
  connect(mapStateToProps, {
    fetchCommitteesMembers,
    fetchCommitteesMembersByCommitteeMemberId,
    fetchAllMembershipsForBoard,
    fetchMembershipsForBoardCount,
    fetchMembershipsForBoardByPage
  })(CommitteeMemberList)
);
